import { ReactElement, memo } from 'react';

import { getInitialsNameLetterUpperCase } from '~utils/user';
import { getCompanyToBillingItemTextType } from '~utils/billingItem';

import { BillingItemCompanyInfoProps } from './types';
import {
  BillingItemCompanyInfoContainer,
  BillingItemCompanyInfoAvatar,
  BillingItemCompanyInfoTypography,
} from './styles';

const BillingItemCompanyInfo = ({
  name,
  type,
  fontSize = 14,
  fontWeight,
}: BillingItemCompanyInfoProps): ReactElement => (
  <BillingItemCompanyInfoContainer size={fontSize}>
    <BillingItemCompanyInfoAvatar size={fontSize} type={type}>
      {getInitialsNameLetterUpperCase(getCompanyToBillingItemTextType(type))}
    </BillingItemCompanyInfoAvatar>

    <BillingItemCompanyInfoTypography variant="inherit" fontWeight={fontWeight}>
      {name}
    </BillingItemCompanyInfoTypography>
  </BillingItemCompanyInfoContainer>
);

export default memo(BillingItemCompanyInfo);
